export default __webpack_public_path__ + "static/media/casesmob.a68ac596.png";